// import React from 'react';
// import moment from 'moment';
// import styles from './Footer.module.css';

// const Footer = () => {
//   const currentYear = moment().format('YYYY');
//   return <div className={styles.footer}>
//     <span className={styles.footerText}>
//       &#169; Copyright {currentYear} <span className={styles.companyName}>Tata Motors</span>.
//       All rights reserved
//     </span>
//   </div>
// };

// export default Footer;




import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className={styles.footer}>
      <span className={styles.footerText}>
        &#169; Copyright {currentYear} <span className={styles.companyName}>Tata Motors</span>.
        All rights reserved.
        <span className={styles.poweredBy}>
          Powered by <a href="https://www.noviga.tech/" target="_blank" rel="noopener noreferrer" className={styles.link}>Noviga Tech</a>
        </span>
      </span>
    </div>
  );
};

export default Footer;



// import React from 'react';
// import moment from 'moment';
// import styles from './Footer.module.css';

// const Footer = () => {
//   const currentYear = moment().format('YYYY');
//   return (
//     <div className={styles.footer}>
//       <span className={styles.footerText}>
//         &#169; Copyright {currentYear} <span className={styles.companyName}>Tata Motors</span>.
//         All rights reserved.
//       </span>
//       <span className={styles.poweredBy}>Powered by Noviga Tech</span>
//     </div>
//   );
// };

// export default Footer;
